import React, {Fragment, useCallback, useEffect, useRef, useState} from 'react';
import {DosingMethod, Excipient, Ingredient, ResourceType} from '../../domain/types';
import {DialogHeader} from '../Dialog';
import {Button, DialogActions, DialogContent, InputAdornment, Typography} from '@material-ui/core';
import NumericTextField from '../NumericTextField';

export const units = { [DosingMethod.Percent]: '%', [DosingMethod.Amount]: 'kg', [DosingMethod.Liter]: 'l' }
export const labels = { [DosingMethod.Percent]: 'Percentage', [DosingMethod.Amount]: 'Hoeveelheid', [DosingMethod.Liter]: 'Liters' }

type ChangeIngredientDialogContentProps = {
  ingredient: Ingredient,
  editPercentage: boolean,
  onChange: (ingredient: Ingredient) => void,
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void
  binderTotal?: number,
}

const ChangeIngredientDialogContent: React.FC<ChangeIngredientDialogContentProps> = ({ onClose, onChange, ingredient, editPercentage, binderTotal }) => {
  const [amount, setAmount] = useState(undefined as number | undefined);
  const [percentage, setPercentage] = useState(0 as number | undefined);
  const inputRef = useRef() as React.RefObject<HTMLInputElement>;

  useEffect(() => {
    if (ingredient && ingredient.amount && ingredient.resource.type === ResourceType.Excipient) {
     if((ingredient.resource as Excipient).dosingMethod===DosingMethod.Liter)
       setAmount(ingredient.amount / (ingredient.resource.density / 1000))
     else {
       if(ingredient.editPercentage)
         setAmount(ingredient.amount * 100 / (binderTotal || 0))
     }
    } else if (ingredient) {
      setAmount(ingredient.amount)
    }
    ingredient && setPercentage(ingredient.percentage || 0)
  }, [ingredient, binderTotal])

  useEffect(() => {
    setTimeout(() => inputRef.current && inputRef.current.focus(), 100);
  }, [inputRef]);

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (ingredient.resource.type === ResourceType.Excipient) {
      let calcAmount = amount || 0
      if((ingredient.resource as Excipient).dosingMethod===DosingMethod.Liter)
        calcAmount *= ingredient.resource.density / 1000
      else {
        if(ingredient.editPercentage) {
          calcAmount=binderTotal/100 * percentage
        }
      }

      onChange({ ...ingredient, amount: calcAmount })
    } else {
      ingredient.editPercentage ? onChange({ ...ingredient, percentage }) : onChange({ ...ingredient, amount: amount || 0 });
    }
  }, [amount, percentage, ingredient, editPercentage, onChange, binderTotal]);

  return ingredient ? <form onSubmit={handleSubmit} noValidate={true}>
    <DialogHeader onClose={e => onClose && onClose(e, 'backdropClick')}>{ingredient.resource.name}</DialogHeader>
    <DialogContent>
      <NumericTextField
        label={ingredient.resource.type === ResourceType.Excipient ?
          (ingredient.editPercentage ? 'Percentage' : 'Hoeveelheid') :
          labels[(ingredient.resource as Excipient).dosingMethod]}
        value={ingredient.editPercentage ? percentage : amount}
        onChange={e => (ingredient.editPercentage ? setPercentage(e.target.value) : setAmount(e.target.value))}
        onFocus={() => inputRef.current && inputRef.current.select()}
        InputProps={{
          endAdornment: <InputAdornment position="end">{ingredient.resource.type === ResourceType.Excipient ?
          ingredient.editPercentage ? '%' : units[(ingredient.resource as Excipient).dosingMethod] : 'kg'}</InputAdornment>
        }}
        fullWidth={true}
        inputRef={inputRef}
        maximumFractionDigits={2}
      />
    </DialogContent>
    <DialogActions>
      <Button color="primary" type="submit">Opslaan&nbsp;&nbsp;<Typography variant="caption">(ENTER)</Typography></Button>
    </DialogActions>
  </form> : <Fragment />;
}

export default ChangeIngredientDialogContent;
